module.exports = __webpack_public_path__ + "static/Boogy_Brut_WEB-Regular-cc3dd8cf2a7f4e8acb6f307465329514.woff2";